import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui";
import { ChevronDown } from "lucide-react";

export type FileSortKey = "dateModified" | "dateCreated" | "name";

interface FileRepositorySortProps {
  sortKey: FileSortKey;
  onSortChange: (key: FileSortKey) => void;
}

const SORT_OPTIONS: Array<{ key: FileSortKey; label: string }> = [
  { key: "dateModified", label: "Date modified" },
  { key: "dateCreated", label: "Date created" },
  { key: "name", label: "Name" },
];

export function FileRepositorySort({
  sortKey,
  onSortChange,
}: FileRepositorySortProps) {
  const activeOption = SORT_OPTIONS.find((option) => option.key === sortKey);

  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2">
            Sort: {activeOption?.label ?? "Date modified"}
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Sort files by</DropdownMenuLabel>
          <DropdownMenuRadioGroup
            value={sortKey}
            onValueChange={(value) => {
              onSortChange(value as FileSortKey);
            }}
          >
            {SORT_OPTIONS.map((option) => (
              <DropdownMenuRadioItem key={option.key} value={option.key}>
                {option.label}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
